import { css } from "lit";
export default css `

    .summary {
        font-size: 1.1rem;
        font-family: var(--font-stack-bold), monospace;
        color: var(--primary-color);
    }

    p > code, pre {
        font-family: var(--font-stack), monospace;
        border: 1px solid var(--secondary-color-lowalpha);
        color: var(--secondary-color);
        border-radius: 0;
        padding: -1px;
        background-color: var(--secondary-color-very-lowalpha);
        vertical-align: top;
    }
    
    p > img {
        max-width: 800px;
    }
    
    .major {
        color: var(--primary-color);
        font-family: var(--font-stack-bold), monospace;
    }

    .major-icon {
        color: var(--primary-color);
        font-family: var(--font-stack-bold), monospace;
    }

    h1, h2, h3, h4, h5, h6, strong, b {
        font-family: var(--font-stack-bold), monospace;
        font-weight: normal;
    }
    
    i {
        font-family: var(--font-stack-italic), monospace;
    }

    em {
        font-family: var(--font-stack-bolditalic), monospace;
    }
    
    ul {
        padding-left: 20px;
    }

    ul > li {
        font-family: var(--font-stack), monospace;
        font-weight: normal;
        list-style-type:  none;
        line-height: 1.8em;
    }

    ul > li code {
        font-family: var(--font-stack), monospace;
        border: 1px solid var(--secondary-color-lowalpha);
        color: var(--secondary-color);
        border-radius: 0;
        padding: 0 5px 1px 5px;
        background-color: var(--secondary-color-very-lowalpha);
        vertical-align: top;
    }

    ul > li:before {
        color: var(--primary-color);
        font-family: var(--font-stack-bold), monospace;
        margin-right: 10px;
        content: ">"
    }

    ul > li > ul > li:before {
        color: var(--primary-color);
        font-family: var(--font-stack-bold), monospace;
        margin-right: 10px;
        content: "-"
    }
    ul > li > ul > li> ul > li:before {
        color: var(--primary-color);
        font-family: var(--font-stack-bold), monospace;
        margin-right: 10px;
        content: "*"
    }
    

    @media only screen and (max-width: 1000px) {
       .major-icon {
           display: none;
       }
    }

`;
